export default "__VITE_ASSET__CTkTsDKf__";